import { KeyboardAvoidingView } from "react-native";

export default KeyboardAvoidingView;
